// extracted by mini-css-extract-plugin
export default {"text":"ListItem_text__Gw35x","listItem":"ListItem_listItem__tsCBI"};